var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuthImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 582.648,
    height: 484.167,
    viewBox: "0 0 582.648 484.167",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#aee4ed;}.b{fill:#30c5cc;}.c{fill:#3d9cff;}.d{fill:#445279;}.e{fill:#e0f3fb;}.f{fill:#2a3554;}.g{fill:#db5a28;}.h{fill:#2f2f8e;}.i{fill:#4c49a2;}.j{fill:#fff;}.k{fill:#e67750;}.l{fill:#efefef;}.m{fill:#fd9e71;}.n{fill:#201251;}.o{fill:#0b9b9b;}.p{fill:#31d0a8;}.ag,.q{fill:#feba40;}.r{fill:#fedb9b;}.s{fill:#4cb0dd;}.t{fill:#75d5ef;}.u{fill:#fdbe44;}.v{fill:#98dbe5;}.w{fill:#86d2e8;}.x{fill:#f6fffa;}.y{fill:#ffe780;}.z{fill:#1fb288;}.aa{fill:#9e472d;}.ab{fill:#262845;}.ac{fill:#6aa5cc;}.ad{fill:#96c4ea;}.ae{fill:#1a133a;}.af{fill:#e79673;}.ag{opacity:0.5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-314.831 -125.264)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M516.289,409.268c0,5.6-34.424,10.139-76.887,10.139s-76.888-4.54-76.888-10.139,34.424-10.139,76.888-10.139S516.289,403.668,516.289,409.268Z",
    transform: "translate(33.085 190.023)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 77.732,
    cy: 7.604,
    rx: 77.732,
    ry: 7.604,
    transform: "translate(742.015 579.014)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M338.849,350.623H329.7V341.47h-5.711v9.154h-9.154v5.711h9.154v9.153H329.7v-9.153h9.153Z",
    transform: "translate(0 150.016)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M338.565,339.247a5.658,5.658,0,1,1-5.658-5.659A5.657,5.657,0,0,1,338.565,339.247Z",
    transform: "translate(8.617 144.547)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 493.292,
    height: 395.421,
    rx: 18.482,
    transform: "translate(357.674 161.625)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 367.257,
    height: 463.473,
    rx: 12.013,
    transform: "translate(836.057 175.707) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 439.18,
    height: 346.02,
    rx: 7.76,
    transform: "translate(384.73 186.326)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M322.64,365.139a56.455,56.455,0,0,0,48.212,27.278h456.1a56.455,56.455,0,0,0,48.212-27.278Z",
    transform: "translate(5.418 166.439)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M328.536,373.144h540.73a56.861,56.861,0,0,0,5.9-8.005H322.64A56.865,56.865,0,0,0,328.536,373.144Z",
    transform: "translate(5.418 166.439)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 122.794,
    height: 68.72,
    transform: "translate(419.257 392.006)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(415.248 216.096)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 46.193,
    height: 6.363,
    transform: "translate(124.119)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 28.2,
    height: 6.363,
    transform: "translate(64.39)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 55.87,
    height: 6.363
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 12.116,
    height: 6.363,
    transform: "translate(101.418)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 28.102,
    height: 6.363,
    transform: "translate(182.066)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(415.248 234.684)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 17.329,
    height: 6.363,
    transform: "translate(124.119)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 17.329,
    height: 6.363,
    transform: "translate(148.34)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 28.2,
    height: 6.363,
    transform: "translate(35.663)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 27.667,
    height: 6.363
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 46.438,
    height: 6.363,
    transform: "translate(71.602)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(399.708 392.942)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M454.277,431.8c-2.92-9.372-8.588-49.022-9.857-64.551-.268-3.289-36.4-17.4-36.4-17.4-21.151-.535-32.036,7.76-32.036,7.76l50.789,17.155c0,22.906,19.527,57.454,19.527,57.454Z",
    transform: "translate(-357.278 -237.131)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M414.287,380.477,399.2,433.006l8.617,1.879c3.755-12.392,25.462-54.856,26.052-59.905.251-2.151.095-3.813-.708-4.487s-25.152-15.224-32.224-16.815c-9.472-2.127-23.538-5.537-23.538-5.537a28.367,28.367,0,0,0-6.382,21.78C372.566,383.406,414.287,380.477,414.287,380.477Z",
    transform: "translate(-360.859 -238.298)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M391.754,312.714s-16.53,1.465-17.281,5.973,7.887,33.025,7.887,33.025l-8.4,22.411s23.841,5.868,35.457,1.491c1.1.506,2.981-23.528,2.981-23.528l4.138-11.808,5.249,17.818,12.018,16.9,7.885-6.384-8.756-15.392s-13.554-30.932-17.155-34.531C409.021,311.926,391.754,312.714,391.754,312.714Z",
    transform: "translate(-358.68 -262.899)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M397.955,320.369l-1.281-17H384.282v15.878c-1.568.174,1.69,12.85,11.676,12.85C395.958,332.1,400.618,330.406,397.955,320.369Z",
    transform: "translate(-351.779 -269.363)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M379.738,330.4c1.445,5.126,2.622,9.011,2.622,9.011l-8.4,22.411s18.141,4.463,30.484,2.7c-1.1-.808-15.738-10.671-16.454-14.972C386.49,340.543,379.738,330.4,379.738,330.4Z",
    transform: "translate(-358.68 -250.604)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M411.916,295.21c-1.049-4.352-7.837-5.612-18.568-4.35-7.3.857-8.938,7.573-9.143,12.567-.108.027-.219.039-.329.073a5.935,5.935,0,0,0-4.175,5.888A5.8,5.8,0,0,0,381.147,313a6.062,6.062,0,0,0,4.416,2.819,5.6,5.6,0,0,0,1.526-.032c3.039,6.325,8.613,14.206,16.434,13.266C414.99,321.038,411.916,295.21,411.916,295.21Z",
    transform: "translate(-354.703 -278.365)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M387.281,308.679a8.318,8.318,0,0,1,2.976-9.7c5.348-4.014,5.708,1.912,11.345,2.639s11.2.268,10.593,3.992c3.411-8.417-1.521-13.231-7.036-15.87s-14.151-3.776-20.15,1.231S379.821,308,379.821,308C383.776,306.091,384.838,307.639,387.281,308.679Z",
    transform: "translate(-354.64 -280.38)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M395.309,293.886s-4.98-13.378-14.415-10.067-5.18,22.327-6.222,30.6-6.968,8.634-9.1,4.956c-3.945,7.5,11.511,15.121,16.544,7.914s2.133-25.47,5.351-27.334,6.459.557,6.459.557Z",
    transform: "translate(-364.94 -283.293)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M379.1,315.83c-3.97,2.29-11.266,29.646-11.266,34.152s35.178,26.942,35.178,26.942,1.623-5.537,5.378-6.664c-.752-.376-26.287-24.785-26.287-24.785l6.76-19.132S388.864,310.2,379.1,315.83Z",
    transform: "translate(-362.931 -261.545)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M387.014,353.895l35.857-1.1,23.282,8.637-39.412,2.091Z",
    transform: "translate(-349.623 -235.068)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M406.741,363.072l-19.727-7.642v-1.987l21.286,7.678Z",
    transform: "translate(-349.623 -234.618)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M398.66,372.383l11.852-32.358,39.2,2.1-11.641,28.915Z",
    transform: "translate(-341.542 -243.929)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M413.155,349.71c-1.165,2.331-.813,4.87.788,5.669s3.842-.439,5.007-2.769.815-4.87-.786-5.669S414.323,347.379,413.155,349.71Z",
    transform: "translate(-331.962 -239.299)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M393.981,347.475s14.269,11.264,12.767,12.016-7.885.75-11.264-1.126-6.88-4.226-6.88-4.226S389.85,347.849,393.981,347.475Z",
    transform: "translate(-348.521 -238.76)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.615 193.769)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M398.1,397.876c2.534,2.566,11.151,6.459,15.4,7.51,4.551,1.126,3.755,4.949.428,4.949-6.532,0-21.058-.818-28.218-.818-1.126-3.381.815-7.9,3.095-10.944C389.492,397.646,397.735,397.51,398.1,397.876Z",
    transform: "translate(-385.375 -397.688)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(86.061 193.769)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M428.469,397.876c2.534,2.566,11.151,6.459,15.4,7.51,4.551,1.126,3.755,4.949.429,4.949-6.532,0-21.058-.818-28.218-.818-1.126-3.381.815-7.9,3.095-10.944C419.865,397.646,428.107,397.51,428.469,397.876Z",
    transform: "translate(-415.747 -397.688)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(419.921 365.294)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 34.435,
    height: 9.488
  }), /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 34.434,
    height: 9.488,
    transform: "translate(87.696)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "p",
    width: 34.435,
    height: 9.488,
    transform: "translate(43.848)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(535.614 182.29)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "q",
    width: 112.346,
    height: 41.852,
    transform: "translate(0 26.754) rotate(-13.777)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "r",
    width: 82.751,
    height: 5.787,
    transform: "translate(7.118 30.853) rotate(-13.777)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "r",
    width: 69.146,
    height: 5.787,
    transform: "translate(9.567 40.842) rotate(-13.777)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "r",
    width: 32.807,
    height: 5.786,
    transform: "matrix(0.971, -0.238, 0.238, 0.971, 12.25, 51.783)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 17.571,
    height: 5.783,
    transform: "translate(80.07 23.708) rotate(-13.777)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 122.548,
    height: 100,
    transform: "translate(418.623 254.835)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(550.347 312.511)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "s",
    width: 241.006,
    height: 45.097
  }), /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 65.22,
    height: 32.045,
    transform: "translate(168.574 6.527)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 150.748,
    height: 6.181,
    transform: "translate(8.813 8.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 150.748,
    height: 6.181,
    transform: "translate(8.813 19.458)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 101.49,
    height: 6.181,
    transform: "translate(8.813 30.447)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(550.402 389.822)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 231.606,
    height: 108.669
  }), /*#__PURE__*/React.createElement("rect", {
    className: "u",
    width: 231.606,
    height: 18.018
  }), /*#__PURE__*/React.createElement("rect", {
    className: "v",
    width: 133.737,
    height: 9.172,
    transform: "translate(5.617 43.638)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "v",
    width: 119.933,
    height: 9.172,
    transform: "translate(5.617 59.946)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "v",
    width: 80.888,
    height: 9.172,
    transform: "translate(5.617 76.252)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "v",
    width: 48.207,
    height: 9.172,
    transform: "translate(5.617 28.614)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(152.38 28.167)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "w",
    width: 69.951,
    height: 69.951
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M580.274,326.467a8.856,8.856,0,0,0,1.756-5.3v-5.344a8.908,8.908,0,1,0-17.816,0v5.344a8.863,8.863,0,0,0,1.928,5.525,21.018,21.018,0,0,0-14.034,19.822h44.055S594.458,330.578,580.274,326.467Z",
    transform: "translate(-538.146 -291.947)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.421 4.916)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 4.546,
    cy: 4.546,
    r: 4.546
  }), /*#__PURE__*/React.createElement("circle", {
    className: "y",
    cx: 4.546,
    cy: 4.546,
    r: 4.546,
    transform: "translate(14.566)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "z",
    cx: 4.546,
    cy: 4.546,
    r: 4.546,
    transform: "translate(31.464)"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 81.112,
    height: 81.112,
    transform: "translate(703.224 211.757)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(763.339 293.433)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M620.583,389.215s.7,2.134-5.844,5.119-13.451,1.933-15.146,4.44a13.73,13.73,0,0,0-2.09,4.883h37.229s-.281-10.28-4.5-14.843C630.772,389.8,620.583,389.215,620.583,389.215Z",
    transform: "translate(-567.205 -110.566)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M644.158,389.2s.672,2.051-5.62,4.922-12.933,1.856-14.562,4.268a13.2,13.2,0,0,0-2.01,4.7h35.8s-.271-9.884-4.324-14.272C653.953,389.757,644.158,389.2,644.158,389.2Z",
    transform: "translate(-550.232 -110.566)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 44.567)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M625.657,289.175l-27.031,4.753-19.011-40.695,29.11-2.376Z",
    transform: "translate(-579.616 -250.856)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.236 78.768)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M586.9,271.05a.045.045,0,0,1,.022,0C586.825,271.089,586.811,271.094,586.9,271.05Z",
    transform: "translate(-586.84 -271.048)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M619.3,229.646s-3.564,7.128-3.564,13.663c0,4.568.581,11.168.93,14.728a2.054,2.054,0,0,0,2.649,1.765l5.332-1.64-.3,7.722,14.874-.258,3.247-31.228S630,220.735,619.3,229.646Z",
    transform: "translate(-554.55 -223.1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M620.739,247.486s.835-6.183,5.5-4.9-.681,7.519-.681,7.519l4.455,8.02a13.689,13.689,0,0,0,10.4-.3s4.95-15.05,4.95-19.8-4.331-7.963-4.331-7.963-11.61-5.8-17.847-5.5-6.833,6.535-6.833,6.535-2.377,4.753,0,6.831S620.739,247.486,620.739,247.486Z",
    transform: "translate(-554.862 -224.545)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M636.575,247.125l-.673,4.3-15.368.059S623.505,246.728,636.575,247.125Z",
    transform: "translate(-551.225 -208.895)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M596.089,275.036s1.076-3.369-3.268-5.347c.112-.789-.869-4.733-1.782-5.644s-1.486,4.158-1.486,4.158-4.253-7.575-5.347-5.644,9.606,16.834,9.9,17.426S596.089,275.036,596.089,275.036Z",
    transform: "translate(-576.485 -198.388)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M619.025,298.915l-10.3,87.132,2.09,67.541,12.96-.926s3.664-35.524,3.962-44.435-2.377-22.576-2.377-22.576l13.07-53.863,2.173.4.6,53.072,11.906,67.405,10.895.525s.269-34.761-.622-43.376-5.544-25.841-5.544-25.841l4.753-54.954s4.751-14.455-3.764-30.694C657.738,298.421,619.025,298.915,619.025,298.915Z",
    transform: "translate(-559.418 -173.356)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M642.6,249.711s-18.416,5.94-21.783,9.308S607.8,297.083,607.8,297.083L593.244,282.5l-4.509,10.575s17.03,25.349,22.378,26.14,17.427-32.08,17.427-32.08,1.1,17.955,3.167,26.932a56.18,56.18,0,0,1,1.189,18.614c16.479,2.991,30.5,2.377,39.8-.595l4.612-34.6s6.279.733,8.259-1.445-7.128-38.022-9.108-40.793-18.5-5.605-18.5-5.605Z",
    transform: "translate(-573.289 -207.125)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M632.569,263.913c-.1-.7-1.26-.532-1.233.168a225.619,225.619,0,0,1-2.29,44.142c-.156.989,1.314,1.442,1.535.423A128.437,128.437,0,0,0,632.569,263.913Z",
    transform: "translate(-545.327 -197.542)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M643.625,270.37c-.1-.5-.854-.368-.864.117a147.381,147.381,0,0,1-2.885,25.557c-1.465,7.59-2.807,15.189-2.316,22.95.07,1.086,1.75,1.1,1.7,0-.376-8.964,1.447-17.618,3.078-26.38C643.7,285.337,645.1,277.732,643.625,270.37Z",
    transform: "translate(-539.482 -192.969)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M621.285,270.109c-4.944,3.142-6.8,9.294-8.695,14.528-2.561,7.08-5.121,14.037-10.7,19.351-.832.791.408,2.012,1.252,1.254,10.3-9.269,9.807-24.42,18.588-34.551C621.995,270.388,621.659,269.87,621.285,270.109Z",
    transform: "translate(-564.35 -192.973)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M654.806,297.451s-24.951,3.168-40-1.585c.395,0,0,4.753,0,4.753A75.606,75.606,0,0,0,656,302.2C655.819,302.133,654.806,297.451,654.806,297.451Z",
    transform: "translate(-555.199 -175.059)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(563.209 211.567)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M494.843,356.675s-2.066,4.506-5.634,5.258-12.955,2.815-14.457,4.13-1.5,4.694-1.5,4.694h29.8s-.054-9.021-1.784-13.71C501.978,357.051,494.843,356.675,494.843,356.675Z",
    transform: "translate(-453.289 -51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M528.762,356.675s-2.065,4.506-5.632,5.258-12.956,2.815-14.459,4.13-1.5,4.694-1.5,4.694h29.8s-.054-9.021-1.784-13.71C535.9,357.051,528.762,356.675,528.762,356.675Z",
    transform: "translate(-429.753 -51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M521.371,189.023s-8.3-2.119-8.8-.8,12.831,5.264,12.831,5.264l12,33.286-4.494,10.649,8.261,9.013s9.011-12.2,9.763-15.773-21.405-39.428-21.405-39.428-4.4-13.974-5.07-14.645-8.61-.251-10.407-.22,5.232,7.148,5.232,7.148Z",
    transform: "translate(-426.016 -176.214)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M500.792,200.662s-3.955,5.552-4.8,11.467a38.639,38.639,0,0,0,.281,11.547l7.258-.241v6.791h14.428a75.775,75.775,0,0,1,.845-7.959c.564-2.817,4.506-8.168,4.506-8.168l-6.477-18.306-9.294-.845Z",
    transform: "translate(-437.727 -163.215)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M502.6,212.312s2.536-5.915,5.634-3.662-.845,7.041-.845,7.041,1.972,8.168,5.351,9.294l3.379,1.126s8.732-8.168,10.139-10.421-2.253-15.209-4.789-18.024-13.519-2.536-14.362-3.943-3.662-3.943-6.479-2.817-2.253,10.421-2.253,10.421,3.483,3,3.713,5.161-1.382,5.026-1.382,5.026Z",
    transform: "translate(-435.887 -166.215)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M502.123,219.474s14.4-2.1,22.657-2.29,21.4,4.13,21.4,4.13l9.567-10.241,12.184,11.452S557.563,237.83,554.221,241.4s-5.783,20.281-6.535,25.35-2.629,34.736-2.629,34.736S536.234,312,500,300.548c-.376-.376,1.5-21.78,1.314-27.037s-4.882-23.094-5.82-27.413-15.91-12.96-15.91-12.96-1.85-10.521,5.06-15.585C485.538,218.122,502.123,219.474,502.123,219.474Z",
    transform: "translate(-449.053 -152.028)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M481.052,196.568s-5.446,5.07-5.822,7.135,7.492,25.591,7.492,25.591l14.328,8.388-5.06,15.585s-15.634-10.885-17.887-14.078-6.2-35.11-6.2-35.11-5.07-6.384-5.444-8.075-1.557-7.216-.684-8.3,6.681-7.1,7.531-5.312,3.977,14.791,3.977,14.791S479.738,194.316,481.052,196.568Z",
    transform: "translate(-461.465 -172.157)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M496.616,264.147l-8.168,76.981L484.224,422.8l14.083.562s8.732-54.19,8.872-62.441-.142-18.107-.142-18.107l9.013-41.12h5.07l10.421,53.512,10.7,66.467,11.266.562s1.689-41.4,0-49.85-4.225-16.617-4.225-16.617l-5.07-55.482s4.505-19.715-2.536-35.205C540.27,262.269,496.616,264.147,496.616,264.147Z",
    transform: "translate(-445.674 -115.627)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M450.583,215.944H441.43v-9.154h-5.711v9.154h-9.154v5.711h9.154v9.153h5.711v-9.153h9.153Z",
    transform: "translate(80.557 115.133)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M404.12,281.232a22.117,22.117,0,1,1,22.115-22.118A22.147,22.147,0,0,1,404.12,281.232Zm0-32.692a10.575,10.575,0,1,0,10.573,10.573A10.589,10.589,0,0,0,404.12,248.54Z",
    transform: "translate(75.886 26.507)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M660.083,180.03h-9.153v-9.154h-5.711v9.154h-9.154v5.711h9.154v9.153h5.711v-9.153h9.153Z",
    transform: "translate(222.891 31.648)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M627.876,141.719a5.658,5.658,0,1,1-5.658-5.661A5.658,5.658,0,0,1,627.876,141.719Z",
    transform: "translate(209.358 7.489)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M567.071,216.071A17.47,17.47,0,1,1,584.542,198.6,17.494,17.494,0,0,1,567.071,216.071Zm0-25.823a8.353,8.353,0,1,0,8.354,8.352A8.362,8.362,0,0,0,567.071,190.248Z",
    transform: "translate(177.031 36.744)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M608.8,153.885a14.311,14.311,0,1,1,14.311-14.311A14.33,14.33,0,0,1,608.8,153.885Zm0-21.153a6.842,6.842,0,1,0,6.843,6.841A6.85,6.85,0,0,0,608.8,132.732Z",
    transform: "translate(194.044 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ag",
    width: 65.931,
    height: 6.181,
    transform: "translate(710.292 263.426)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ag",
    width: 65.931,
    height: 6.181,
    transform: "translate(710.292 277.563)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "q",
    width: 60.257,
    height: 6.181,
    transform: "translate(427.339 326.03)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "q",
    width: 60.257,
    height: 6.181,
    transform: "translate(427.339 340.166)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthImage);
export default __webpack_public_path__ + "static/media/auth_image.64305d6e4f1a9a0df83da7f43d3ddf6f.svg";
export { ForwardRef as ReactComponent };